import { pipe } from 'ramda';
import { useCallback, useMemo } from 'react';
import {
  Configuration,
  EnabledSourcesConfiguration,
} from 'api/timesheets/configuration/configuration';
import { filter, ifPresent, map } from 'core/maybe';
import { maybeValueOf } from 'core/state';
import { SetState, State, UseStateResult } from './state';

const sourceType = ['TASK', 'PHASE', 'PROJECT', 'ADHOC', 'MILESTONE'];

const toHash = (
  enabledSourcesConfiguration: EnabledSourcesConfiguration,
): string => {
  return sourceType.map((x) => enabledSourcesConfiguration[x]).join(',');
};

export const useEnabledSources = (
  configuration: State<Configuration>,
  setConfiguration: SetState<Configuration>,
): UseStateResult<EnabledSourcesConfiguration> => {
  const enabledSources = useMemo(
    () =>
      pipe(
        () => configuration,
        State.map((c) => c.enabledSourceTypes),
      )(),
    [configuration],
  );
  const setEnabledSources = useCallback(
    (next: EnabledSourcesConfiguration) =>
      pipe(
        () => configuration,
        maybeValueOf,
        filter((x) => toHash(x.enabledSourceTypes) !== toHash(next)),
        map((x) => ({ ...x, enabledSourceTypes: next })),
        ifPresent(setConfiguration),
      )(),
    [configuration, setConfiguration],
  );

  return [enabledSources, setEnabledSources];
};
